import { render, staticRenderFns } from "./attach-customers.vue?vue&type=template&id=1d947aeb"
import script from "./attach-customers.vue?vue&type=script&lang=js"
export * from "./attach-customers.vue?vue&type=script&lang=js"
import style0 from "./attach-customers.vue?vue&type=style&index=0&id=1d947aeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports